module.exports = __webpack_public_path__ + "static/media/18ECA21.f9072796.jpg";